import "./HowWeWork.module.css";
import Hoofdmenu from "@/reusable_sections/Header";
import Werkwijze from "./sections/Werkwijze";
import DuidelijkeEnZorgvuldigeeZorg from "./sections/DuidelijkeEnZorgvuldigeeZorg";
import VanAanmeldingTotPassendeZorg from "./sections/VanAanmeldingTotPassendeZorg";
import BespreekUwSituatie from "./sections/BespreekUwSituatie";
import Footer from "@/reusable_sections/Footer";
export default function HowWeWorkPage() {
  return <div>
      <Hoofdmenu />
      <Werkwijze />
      <DuidelijkeEnZorgvuldigeeZorg />
      <VanAanmeldingTotPassendeZorg />
      <BespreekUwSituatie />
      <Footer />
    </div>;
}